export const LOGIN_API_URLS = {
  MATHFLAT: '/mathFLAT/login',
}
